var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    className: "wd-accent-laptop-play wd-accent",
    focusable: "false",
    role: "presentation",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    className: "wd-icon-container"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005DBA",
    fillRule: "nonzero",
    d: "M50 40a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2V13a2 2 0 0 1 2-2h40a2 2 0 0 1 2 2v27zM8 13v27h40V13H8zM6 42v2h44v-2H6zm26.69-15.51v.005c.191.1.31.296.31.508a.575.575 0 0 1-.31.508l-7.788 4.401a.6.6 0 0 1-.607.011.574.574 0 0 1-.295-.519v-8.808a.574.574 0 0 1 .295-.52.6.6 0 0 1 .607.012l7.789 4.401z",
    className: "color-500"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8 13h40v27H8V13zM6 42h44v2H6v-2zm26.69-15.51l-7.788-4.402a.6.6 0 0 0-.607-.011.574.574 0 0 0-.295.519v8.808a.574.574 0 0 0 .295.52.6.6 0 0 0 .607-.012l7.789-4.401c.19-.101.309-.296.309-.508a.575.575 0 0 0-.31-.508v-.006z",
    className: "french-vanilla-100"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.839c670d5da0391af211eb1137397b65.svg";
export { ForwardRef as ReactComponent };